<template>
  <div>
    <a-card class="c_primary" :loading="loading.page">
      <div slot="title" class="m-display-flex space-between custom">
        <span class="cmain-title">{{page_state}} Kewajiban</span>
      </div>

      <div>
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <div class="steps-content">
          <div v-show="steps[current].content == '1'">
            <a-form :form="form_information">
              <a-row :gutter="[8,8]">
                <a-col span="12">
                  <a-form-item label="Tanggal buat">
                    <a-date-picker disabled v-decorator="['create_date', { rules: [{ required: true }] } ]"
                    />
                  </a-form-item>

                  <a-form-item label="Tanggal Kewajiban">
                    <a-date-picker :disabled="edit_state == 'reminder' || edit_state == 'rekap'" v-decorator="['due_date', { rules: [{ required: true, message: 'Tanggal kewajiban wajib diisi' }] } ]"
                    />
                  </a-form-item>

                  <a-form-item label="Keterangan Kewajiban">
                    <a-input placeholder="Input Keterangan" :disabled="edit_state == 'reminder' || edit_state == 'rekap'" v-decorator="['description', { rules: [{ required: true, message: 'Keterangan kewajiban wajib diisi' }] } ]"
                    />
                  </a-form-item>

                  <a-form-item label="Jenis Anggaran">
                    <a-select
                      placeholder="Pilih Jenis Anggaran"
                      class="width-full"
                      v-decorator="['budget_type', { rules: [{ required: true, message: 'Jenis anggaran wajib diisi' }], initialValue: project_state ? project_state.jns_anggaran_id : undefined } ]"
                      allowClear
                      :loading="loading.input"
                      @change="onChangeBudget"
                      :disabled="edit_state == 'reminder'"
                    >
                      <a-select-option
                        v-for="item in type_anggaran_list"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Cost Center">
                    <a-select
                      placeholder="Pilih Cost Center"
                      class="width-full"
                      v-decorator="['cost_center', { rules: [{ required: true, message: 'Cost center wajib diisi' }] } ]"
                      allowClear
                      @change="onChangeCostCenter"
                      :disabled="edit_state == 'reminder'"
                    >
                      <a-select-option
                        v-for="item in cost_center_list"
                        :key="item.id"
                        :value="item.id"
                        >{{ item.value }} ({{ item.cost_center_label }})</a-select-option
                      >
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Peruntukan">
                    <a-select
                      placeholder="Pilih Peruntukan"
                      class="width-full"
                      v-decorator="['peruntukan', { rules: [{ required: true, message: 'Peruntukan wajib diisi' }] } ]"
                      allowClear
                      @change="onChangePeruntukan"
                      :disabled="edit_state == 'reminder'"
                    >
                      <a-select-option
                        v-for="item in peruntukan_list"
                        :key="item.id"
                        :value="item.id"
                        >{{ item.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Item Anggaran">
                    <a-tree-select
                    class="tree-select-custom"
                    v-decorator="['budget_item', {rules: [{required: true}]}]"
                    show-search
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :placeholder="loading.input_anggaran ? 'Please wait...' : 'Pilih item anggaran'"
                    :tree-data="item_anggaran_list"
                    treeNodeFilterProp="children"
                    allow-clear
                    tree-default-expand-all
                    :treeExpandedKeys="expandedKeys"
                    :loading="loading.input_anggaran"
                    :disabled="loading.input_anggaran || edit_state == 'reminder'"
                    @change="onChangeItemAnggaran"
                    >
                      <span slot="title" slot-scope="item">
                        <table style="width:100%">
                          <tr>
                            <td>
                              <span> {{item.texttitle}} - {{item.kode_anggaran}}</span>
                            </td>
                            <td>
                              <span style="float:right"> {{ customFormatCurrency('IDR', item.remaining_value) }} </span>
                            </td>
                          </tr>
                        </table>
                      </span>
                    </a-tree-select>

                  </a-form-item>

                  <a-form-item label="Prospect No" v-if="selectedCostCenter=='07'">
                    <a-select
                      showSearch
                      :allowClear="true"
                      :not-found-content="null"
                      option-filter-prop="children"
                      v-decorator="[
                        'prospek',
                        {
                          rules: [{ required: true }],
                        },
                      ]"
                      :loading="loading.prospect"
                      :disabled="loading.prospect || listProspect.length==0"
                    >
                      <a-select-option
                        v-for="item in listProspect"
                        :key="item.id_prospek"
                      >
                        {{ item.no_prospek }} - {{ item.description }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col span="12">
                  <a-form-item label="Beneficiary">
                    <a-input placeholder="Input beneficiary" v-decorator="['beneficiary', { rules: [{ required: true, message: 'Beneficiary wajib diisi' }] } ]"
                    :disabled="edit_state == 'reminder' || edit_state == 'rekap'"
                    />
                  </a-form-item>

                  <a-form-item label="Jenis Kewajiban">
                    <a-select
                      placeholder="Pilih jenis kewajiban"
                      class="width-full"
                      v-decorator="['kewajiban_type', { rules: [{ required: true, message: 'Jenis kewajiban wajib diisi' }] } ]"
                      :disabled="edit_state == 'reminder' || edit_state == 'rekap'"
                      allowClear
                    >
                      <a-select-option
                        v-for="item in type_kewajiban_list"
                        :key="item.id"
                        :value="item.value"
                        >{{ item.value }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Nilai Kewajiban">
                    <a-input-number class="m-width-full m-text-align-right" 
                    placeholder="Input nilai kewajiban"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                    :disabled="edit_state == 'reminder' || edit_state == 'rekap'"
                    v-decorator="['kewajiban_value',{ rules: [{ required: true, message: 'Nilai Kewajiban wajib diisi' }, { validator: validateKewajibanValue }] },]" 
                    />
                  </a-form-item>

                  <div class="flex-wrapper">
                    <a-form-item label="Currency" class="flex-items">
                      <a-select
                        placeholder="Pilih Currency"
                        class="width-full"
                        v-decorator="['currency', { rules: [{ required: true, message: 'Currency wajib diisi' }] } ]"
                        :disabled="edit_state == 'reminder' || edit_state == 'rekap'"
                        allowClear
                        @change="onChangeCurrency"
                      >
                        <a-select-option
                          v-for="item in currencies"
                          :key="item.code"
                          :value="item.code"
                          >{{ item.code+' - '+item.name+` (${item.symbol}) ` }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item label="Kurs IDR" class="flex-items">
                      <a-input-number class="m-width-full m-text-align-right" 
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                      :disabled="edit_state == 'reminder' || edit_state == 'rekap'"
                      v-decorator="['kurs_value',{ rules: [{ required: true, message: 'Nilai kurs wajib diisi' }] },]" 
                      />
                    </a-form-item>
                  </div>

                  <a-form-item label="No. Invoice / SK / Referensi">
                    <a-input placeholder="Input No. Invoice / SK / Referensi" 
                    v-decorator="['invoice_number', { rules: [{ required: true, message: 'No Invoice wajib diisi' }] } ]"
                    :disabled="edit_state == 'reminder' || edit_state == 'rekap'"/>
                  </a-form-item>

                  <a-row :gutter="8">
                    <a-col :xs="{span: 24}" :lg="{span: 5}">
                      <a-form-item label="Use CC">
                        <a-radio-group
                        buttonStyle="solid"
                        @change="onChangeIsCc"
                        v-decorator="['is_cc',{ rules: [{ required: true }], initialValue: is_cc },]"
                        :disabled="is_cc_disabled"
                        >
                        <a-radio-button value="1">Yes</a-radio-button>
                          <a-radio-button value="0">No</a-radio-button>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{span: 24}" :lg="{span: 19}">
                      <a-form-item label="User CC" class="flex-items" v-if="is_cc == '1'">
                        <a-select
                          placeholder="Pilih User CC"
                          class="width-full"
                          v-decorator="['user_cc', { rules: [{ required: true }] } ]"
                          allowClear
                          show-search
                          :filterOption="filterUserCC"
                        >
                          <a-select-option
                            v-for="item in user_cc_list"
                            :key="item.id_user_cc"
                            :value="item.id_user_cc"
                            :label="item.no_cc + ' ' + item.tlc_user + ' ' + customFormatCurrency('IDR', item.limit_kredit)"
                            >{{ item.no_cc+' / '+item.tlc_user+` / ${customFormatCurrency('IDR', item.limit_kredit)} ` }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-form-item label="Catatan">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="2"
                      v-decorator="['catatan']"
                    />
                  </a-form-item>

                </a-col>
              </a-row>
            </a-form>
          </div>

          <div v-show="steps[current].content == '2'">
            <a-row :gutter="[8,8]" type="flex" align="stretch">
              <a-col span="10" class="col-flex">
                <a-card class="card-flex">
                  <a-form :form="form_detail">
                    <a-form-item label="Is TAX?">
                      <a-radio-group
                      buttonStyle="solid"
                      @change="onChangeIsTax"
                      v-decorator="['is_tax',{ rules: [{ required: true }], initialValue: is_tax },]"
                      >
                        <a-radio-button value="0">No</a-radio-button>
                        <a-radio-button value="1">Yes</a-radio-button>
                      </a-radio-group>
                    </a-form-item>

                    <a-form-item label="Tanggal Bayar">
                      <a-date-picker v-decorator="['payment_date', { rules: [{ required: true, message: 'Tanggal bayar wajib diisi' }] } ]"
                      />
                    </a-form-item>

                    <a-form-item label="Jenis Pajak" v-if="is_tax == '1'">
                      <a-select
                      placeholder="Pilih jenis pajak"
                      class="width-full"
                      v-decorator="['type_tax', { rules: [{ required: true }] } ]"
                      allowClear
                      @change="onChangeTax"
                      >
                        <a-select-option
                        v-for="item in filteredTypeTax"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.text }}</a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item label="Nama Item">
                      <a-input v-decorator="['item_name', { rules: [{ required: true, message: 'Nama item wajib diisi' }] } ]" placeholder="Masukkan nama item"/>
                    </a-form-item>

                    <a-form-item label="Nilai Bayar">
                      <a-input-number class="m-width-full m-text-align-right" 
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                      v-decorator="['payment_value',{ rules: [{ required: true, message: 'Nilai bayar wajib diisi' }] },]" 
                      />
                    </a-form-item>
                  </a-form>
                  <div class="card-footer">
                    <div class="btn-update" v-if="form_state=='edit'">
                      <a-button type="secondary" @click="cancelEdit">Cancel</a-button>
                      <a-button type="primary" icon="save" @click="editDetail">Update</a-button>
                    </div>
                    <a-button v-else type="primary" icon="plus" class="btn-add" @click="addDetail" :loading="loading.add">Add</a-button>
                  </div>
                </a-card>
              </a-col>
              <a-col span="14" class="col-flex">
                <a-card class="custom-card card-flex ant-col-24">
                  <a-table 
                  size="small"
                  rowKey="key"
                  :columns="columns" 
                  :data-source="detail"
                  :loading="loading.table_detail"
                  :scroll="{ x: 1000 }"
                  bordered>
                    <template slot="no_bayar" slot-scope="text, item">
                      {{ item.no_bayar }}
                    </template>
                    <template slot="payment_date" slot-scope="text, item">
                      {{ moment(item.payment_date).format("YYYY-MM-DD") }}
                    </template>
                    <template slot="type_tax" slot-scope="text, item, index">
                      <span v-if="item.type_tax == 'non_tax'">
                        Non Tax
                      </span>
                      <span v-else><strong><i>({{ findTax(item.type_tax) }})</i></strong></span>
                      <!-- {{ item.type_tax == 'non_tax' ? 'Non Tax' : `${findTax(item.type_tax)}` }} -->
                    </template>
                    <template slot="payment_value" slot-scope="text, item, index">
                      {{ customFormatCurrency(information.currency, item.payment_value) }}
                    </template>
                    <template slot="action" slot-scope="text, item, index">
                      <div class="flex-items-center">
                        <a-button :disabled="form_state == 'edit'" icon="edit" size="small" @click="editAction(item)"></a-button>
                        <!-- <a-button :disabled="form_state == 'edit'" icon="delete" type="danger" size="small"></a-button> -->
                        <a-popconfirm
                          title="Are you sure delete this data?"
                          ok-text="Yes"
                          cancel-text="No"
                          :disabled="form_state == 'edit' || item.required"
                          @confirm="deleteDetail(item)"
                        >
                        <a-button :disabled="form_state == 'edit' || item.required" icon="delete" type="danger" size="small" :loading="item.id == delete_id_state && loading.delete"></a-button>
                        </a-popconfirm>
                      </div>
                    </template>
                  </a-table>
                  <div class="table-note">
                    <i>*PPH tidak diperhitungkan</i>
                  </div>

                  <div class="table-footer">
                    <div class="footer-row">
                      <span class="footer-label">Sub Total</span>
                      <span class="footer-separator">:</span>
                      <span class="footer-value">{{ customFormatCurrency(information.currency, total_payment + total_tax) }}</span>
                    </div>

                    <!-- <div class="footer-row">
                      <span class="footer-label">PPN</span>
                      <span class="footer-separator">:</span>
                      <span class="footer-value">{{ customFormatCurrency('IDR', total_tax) }}</span>
                    </div>

                    <div class="footer-row">
                      <span class="footer-label">PPH</span>
                      <span class="footer-separator">:</span>
                      <span class="footer-value">{{ customFormatCurrency('IDR', total_pph) }}</span>
                    </div> -->

                    <!-- <div class="footer-row">
                      <span class="footer-label">Sisa Bayar</span>
                      <span class="footer-separator">:</span>
                      <span class="footer-value">{{ customFormatCurrency('IDR', remaining_balance) }}</span>
                    </div> -->
                    <a-divider />
                    <div class="footer-row footer-grand">
                      <span class="footer-label">Grand Total</span>
                      <span class="footer-separator">:</span>
                      <span class="footer-value">
                        {{ customFormatCurrency(information.currency, total_payment + total_tax) }}
                      </span>
                    </div>
                  </div>

                </a-card>
              </a-col>
            </a-row>
          </div>

          <div v-show="steps[current].content == '3'">
            <a-row :gutter="[8,8]" type="flex" align="stretch">
              <a-col span="10" class="col-flex">
                <a-card class="card-flex">

                  <a-form :form="form_document">
                    <a-form-item label="Nama Dokumen">
                      <a-input v-decorator="['document_name', { rules: [{ required: true, message: 'Nama dokumen wajib diisi' }] } ]"
                      />
                    </a-form-item>

                    <a-form-item label="Upload Dokumen">
                      <a-upload
                        :show-upload-list="false"
                        :before-upload="beforeUpload"
                        v-decorator="['document', { rules: [{ required: true, message: 'Dokumen wajib diisi' }] } ]"
                      >
                        <a-button icon="upload">
                          Pilih File
                        </a-button>
                      </a-upload>

                      <span v-if="file_state">
                        {{ file_state.name }}
                      </span>
                    </a-form-item>
                  </a-form>
                  <div class="card-footer">
                    <a-button type="primary" icon="plus" class="btn-add" @click="addDocument" :loading="loading.add">Add</a-button>
                  </div>
                </a-card>
              </a-col>
              <a-col span="14" class="col-flex">
                <a-card class="custom-card card-flex">
                  <a-table
                    size="small"
                    :columns="columnsDocument"
                    :data-source="documents"
                    rowKey="key"
                    bordered
                    :loading="loading.list"
                  >
                    <template slot="no" slot-scope="text, record, index">
                      {{ index + 1 }}
                    </template>
                    <template slot="file_name" slot-scope="text, record, index">
                      <a-icon
                          type="file-text"
                          class="margin-right-small"
                        />{{ record.file_name }}
                    </template>
                    <template slot="action" slot-scope="text, record">
                      <div class="flex-items-center">
                        <a-button icon="eye" size="small" @click="viewDocument(record)"></a-button>
                        <a-popconfirm
                          title="Hapus file?"
                          @confirm="deleteDocument(record)"
                        >
                          <a-button type="danger" danger size="small" icon="delete"></a-button>
                        </a-popconfirm>
                      </div>
                    </template>
                  </a-table>
                  <a-table
                    v-if="documentsFromTrans.length>0"
                    size="small"
                    :columns="columnsDocumentFromTrans"
                    :data-source="documentsFromTrans"
                    rowKey="key"
                    bordered
                    :loading="loading.list"
                  >
                    <template slot="file_name" slot-scope="text, record, index">
                      <a-icon
                          type="file-text"
                          class="margin-right-small"
                        />{{ record.file_name }}
                    </template>
                    <template slot="action" slot-scope="text, record">
                      <div class="flex-items-center">
                        <a-button icon="eye" size="small" :loading="loading.print" @click="viewDocument(record)"></a-button>
                      </div>
                    </template>
                  </a-table>
                </a-card>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="steps-action">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next" :loading="loading.next">Next</a-button>
          <a-button
            v-if="current == steps.length - 1"
            type="primary"
            @click="confirm"
            icon="save"
            :loading="loading.submit"
          >
            Submit
          </a-button>
          <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">Previous</a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios'
import _ from 'lodash';
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import { Modal } from 'ant-design-vue'

export default {
  mixins: [CurrencyFormat, GlobalMethod],
  props: ['id'],
  data(){

    const columns = [
      {
        title: "No.",
        key: "no_bayar",
        width: 70,
        align: "center",
        scopedSlots: { customRender: "no_bayar" },
      },
      {
        title: "Tanggal Bayar",
        key: "payment_date",
        width: 140,
        align: "center",
        scopedSlots: { customRender: "payment_date" },
      },
      {
        title: "Nama Item",
        key: "item_name",
        dataIndex: "item_name",
        scopedSlots: { customRender: "item_name" },
      },
      {
        title: "Jenis",
        key: "type_tax",
        width: 120,
        align: "center",
        scopedSlots: { customRender: "type_tax" },
      },
      {
        title: "Nilai Bayar",
        key: "payment_value",
        width: 170,
        align: "right",
        scopedSlots: { customRender: "payment_value" },
      },
      {
        title: "Action",
        key: "action",
        width: 100,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];

    const columnsDocument = [
      {
        title: 'No',
        align: 'center',
        dataIndex: 'no',
        scopedSlots: { customRender: "no" },
      },
      {
        title: 'Nama File',
        dataIndex: 'file_name',
        scopedSlots: { customRender: "file_name" },
      },
      // {
      //   title: 'Ukuran',
      //   customRender: (text, row) => {
      //     return `${(row.size / 1024).toFixed(2)} KB`
      //   }
      // },
      {
        title: 'Action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }
    ];

    const columnsDocumentFromTrans = [
      {
        title: 'Dokumen Transaksi',
        dataIndex: 'file_name',
        scopedSlots: { customRender: "file_name" },
      },
      {
        title: 'Action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }
    ];

    return {
      page_state: "Create",
      current: 0,
      moment,
      steps: [
        {
          title: 'Informasi',
          content: '1',
        },
        {
          title: 'Detail',
          content: '2',
        },
        {
          title: 'Document',
          content: '3',
        },
      ],
      information: {},
      detail: [],
      documents: [],
      loading: {
        input: false,
        input_anggaran: false,
        submit: false,
        page: false,
        next: false,
        table_detail: false,
        add: false,
        delete: false,
        list: false,
        prospect: false,
        print: false,
      },
      directorate_lsit: [],
      selected_directorate: "",
      type_anggaran_list: [],
      cost_center_list: [],
      peruntukan_list: [],
      item_anggaran_list: [],
      type_kewajiban_list: [],
      cost_center_raw: [],
      peruntukan_raw: [],
      item_anggaran_raw: [],
      anggaran_id_state: null,
      peruntukan_id_state: null,
      currencies: [],
      columns,
      form_state: 'create',
      detail_state: {},
      columnsDocument,
      columnsDocumentFromTrans,
      file_state: null,
      information_state: {},
      detail_state: [],
      document_state: [],
      project_state: {},
      detail_id_state: "",
      delete_id_state: "",
      constraint_value: 0,
      is_tax: "0",
      is_cc: "0",
      old_type_tax: "",
      expandedKeys: [],
      edit_state: '',
      user_cc_list: [],
      is_cc_disabled: false,
      documentsFromTrans: [],
      selectedCostCenter: null,
      listProspect: [],
    }
  },

  beforeCreate() {
    this.form_information = this.$form.createForm(this);
    this.form_detail = this.$form.createForm(this);
    this.form_document = this.$form.createForm(this);
  },

  created(){
    this.$store.dispatch("Fetch_TYPE_TAX");
  },
  
  async mounted(){
    if(this.id || this.getSelectedReminder) this.loading.page = true
    
    await this.initialFetch()
    this.form_information.setFieldsValue({
      'create_date': this.moment(new Date()).format("YYYY-MM-DD")
    })
    // revised flow
    if(this.id){
      this.page_state = 'Edit'
      await this.fetchDataEdit()
      this.$store.dispatch("setSelectedReminder", null);
    }
    //create from reminder
    if(this.getSelectedReminder){
      await this.fetchDataEditReminder(this.getSelectedReminder.reminder_ap_id);
    }
  },

  beforeDestroy() {
    this.$store.dispatch("setSelectedReminder", null);
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatusLapUMPD",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax",
      "getSelectedReminder"
    ]),

    total_payment(){
      return this.detail.reduce((total, item) => {
        if(item.type_tax == 'non_tax'){
          return total + Number(item.payment_value || 0)
        }
        return total;
      }, 0)
    },

    total_tax(){
      return this.detail.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();

        if(type.includes('ppn')){
          return total + Number(item.payment_value || 0)
        }
        return total;
      }, 0)
    },

    total_pph() {
      return this.detail.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();

        if (!type.includes('ppn') && type !== 'non_tax') {
          return total + Number(item.payment_value || 0);
        }

        return total;
      }, 0);
    },

    remaining_balance(){
      return this.detail.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();
        
        if (type.includes('ppn') || type == 'non_tax') {
          return total - Number(item.payment_value || 0);
        }

        return total;
      }, (Number(this.information.kewajiban_value || 0)*Number(this.information.kurs_value || 0)))
    },

    filteredTypeTax() {
      return this.getType_tax.filter(item => item.value !== 'bea_masuk');
    }
  },

  watch: {
    anggaran_id_state(){
      this.fetchItemAnggaran()
    },
    peruntukan_id_state(){
      this.fetchItemAnggaran()
    },
    project_state(){
      if(this.project_state){
        this.onChangeBudget(this.project_state.jns_anggaran_id)
      }
    }
  },

  methods: {
    prev(){
      this.current--
    },
    next(){
      if (this.current == 0){
        this.form_information.validateFields((err, values) => {
          if(err) {
            return
          }

          if(values.kewajiban_type == 'Rekapitulasi'){
            if(this.detail && this.detail.length==0){
              const payload = {
                key: 0,
                no_bayar: 1,
                payment_date: values.due_date,
                payment_value: values.kewajiban_value,
                item_name: values.description,
                type_tax: 'non_tax',
                required: true
              }
                this.detail.push(payload)
                this.refreshDetailNumber()
            }
          }

          this.information = values
          if(this.page_state == 'Edit'){
            this.updateInformation(values)
          } else {
            this.current++
          }
        })

      } else if(this.current == 1){
        
        // if(this.remaining_balance == 0){
        //   this.current++
        // } else {
        //   this.$message.error(
        //     `Harap melengkapi detil pembayaran terlebih dahulu`
        //   )
        // }

        if(this.detail.length==0){
          this.$message.error(
            `Harap mengisi detil pembayaran terlebih dahulu!`
          )
          return
        }

        
        const grandtotal = this.total_payment + this.total_tax; 
        if(grandtotal > this.constraint_value){
          this.displayMessageValue("error-other", 
            " Grand total can't be grather than Budget (" + this.customFormatCurrency('IDR', this.constraint_value) + ")!");
          return
        }

        this.current++
      }
      
    },

    async initialFetch(){
      try {
        this.loading.input = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + 'kewajiban/create',
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          }
        })
        if(response){
          this.type_anggaran_list = response.data.jenis_anggaran
          this.cost_center_raw = response.data.cost_center
          this.peruntukan_raw = response.data.peruntukan
          this.type_kewajiban_list = response.data.kewajiban
          this.currencies = response.data.currencies
          this.user_cc_list = response.data.user_cc.filter(item => {
            if (String(item.tlc_user || '').toUpperCase() === 'RIF') {
              return String(item.kategori || '').toLowerCase() === 'direksi'
            }
            return true
          })
        }
        this.loading.input = false
      } catch (error) {
        console.log(error);
        this.loading.input = false
        
      }
    },

    mappingDropdown(params){
      this.cost_center_list = this.cost_center_raw.filter((e) => e.jns_anggaran_id == params.jns_anggaran_id);

      this.anggaran_id_state = params.anggaran_id
      const find = this.cost_center_list.find((e) => e.id == params.anggaran_id)
      if(find){
        const filter_peruntukan = this.peruntukan_raw.filter((e) => e.jns_anggaran_id == find.jns_anggaran_id);
        this.peruntukan_list = filter_peruntukan
        this.selected_directorate = find.directorate
      }
    },

    onChangeBudget(val, create=false){
      try {
        const filter_cost_center = this.cost_center_raw.filter((e) => e.jns_anggaran_id == val);
        this.cost_center_list = filter_cost_center
        this.form_information.setFieldsValue({
          cost_center: undefined,
          peruntukan: undefined,
          budget_item: undefined
        })
        
        if(create && this.project_state){
          this.onChangeCostCenter(this.project_state.anggaran_id)
          this.$nextTick(() => {
            this.form_information.setFieldsValue({
              cost_center: this.project_state.anggaran_id,
            })
          });
        }

        this.listProspect = [];
        this.selectedCostCenter = val;
      } catch (error) {
        console.log(error);
      }
    },

    mappingBudget(val){
      this.cost_center_list = this.cost_center_raw.filter((e) => e.jns_anggaran_id == val)
      this.selectedCostCenter = val
      
      this.mappingCostCenter(this.project_state.anggaran_id)
      this.$nextTick(() => {
        this.form_information.setFieldsValue({
          cost_center: this.project_state.anggaran_id,
        })
      });
    },

    onChangeCostCenter(val, create=false){
      try {
        this.anggaran_id_state = val
        const find = this.cost_center_list.find((e) => e.id == val)
        if(find){
          const filter_peruntukan = this.peruntukan_raw.filter((e) => e.jns_anggaran_id == find.jns_anggaran_id);
          this.peruntukan_list = filter_peruntukan
          this.selected_directorate = find.directorate
        }
        this.form_information.setFieldsValue({
          peruntukan: undefined,
          budget_item: undefined
        })

        if(create && this.project_state){
          this.$nextTick(() => {
            this.form_information.setFieldsValue({
              peruntukan: this.project_state.peruntukan_id,
            })
          });
        }

        if(this.selectedCostCenter=='07'){
          this.getProspectList(val).then(()=>{
            this.$nextTick(() => {
              this.form_information.setFieldsValue({
                prospek: this.project_state.prospek,
              })
            });
          });
        }

      } catch (error) {
        console.log(error);
      }
    },

    mappingCostCenter(val){
      this.anggaran_id_state = val
      const find = this.cost_center_list.find((e) => e.id == val)
      if(find){
        const filter_peruntukan = this.peruntukan_raw.filter((e) => e.jns_anggaran_id == find.jns_anggaran_id);
        this.peruntukan_list = filter_peruntukan
        this.selected_directorate = find.directorate
      }
      
      this.$nextTick(() => {
        this.form_information.setFieldsValue({
          peruntukan: this.project_state.peruntukan_id,
        })
      }); 
      this.fetchItemAnggaran(true);
    },

    onChangePeruntukan(val){
      this.peruntukan_id_state = val
      this.form_information.setFieldsValue({
        budget_item: undefined
      })
    },

    getAllKeys(nodes) {
      let keys = [];

      nodes.forEach(node => {
        keys.push(node.key);
        if (node.children && node.children.length) {
          keys = keys.concat(this.getAllKeys(node.children));
        }
      });
      return keys;
    },

    async fetchItemAnggaran(revise=false){
      this.loading.input_anggaran = true
      this.item_anggaran_list = []
      
      const anggaran_id = revise ? this.project_state.anggaran_id : this.anggaran_id_state
      const peruntukan_id = revise ? this.project_state.peruntukan_id : this.peruntukan_id_state

      if(anggaran_id && peruntukan_id){
        try {
          const response = await axios({
            method: "GET",
            url: this.$serviceUrl + 'kewajiban/item_anggaran',
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            params: {
              anggaran_id: anggaran_id,
              peruntukan_id: peruntukan_id
            }
          })
          this.item_anggaran_list = response.data.data
          this.expandedKeys = this.getAllKeys(this.item_anggaran_list)
          this.loading.input_anggaran = false
          
          if(this.project_state && revise){
            const keyagg = this.information_state.anggaran_dtl_id+";"+this.information_state.anggaran_dtl_val_id
            const itemagg = this.findNodeByValue(this.item_anggaran_list, keyagg);
            this.setNodeValueByKey(this.item_anggaran_list, itemagg.key, 
              {remaining_value: (Number(itemagg.remaining_value) + Number(this.information_state.nilai))})
            this.onChangeItemAnggaran(keyagg)

            this.$nextTick(() => {
              this.form_information.setFieldsValue({
                budget_item: keyagg,
              })
            });
          }
          
        } catch (error) {
          this.loading.input_anggaran = false
          console.log(error);
        }
      }
    },

    onChangeCurrency(val){
      if(val=='IDR'){
        this.form_information.setFieldsValue({
          kurs_value: 1
        })
      }
    },

    refreshDetailNumber() {
      this.detail = this.detail.map((item, index) => ({
        ...item,
        key: index,
        no_bayar: index + 1
      }))
    },

    addDetail() {
      this.form_state = 'create'

      this.form_detail.validateFields((err, values) => {
        if (err) return

        const type = String(values.type_tax || '').toLowerCase();
        const is_pph = type.includes('pph');
        const paymentValue = Number(values.payment_value)

        // if (paymentValue > this.remaining_balance && !is_pph) {
        //   this.$message.error(
        //     `Nilai bayar tidak boleh melebihi sisa bayar (${this.customFormatCurrency('IDR', this.remaining_balance)})`
        //   )
        //   return
        // } else 
        
        if(paymentValue == 0){
          this.$message.error(`Nilai bayar tidak boleh 0`)
          return
        }

        const payload = {
          key: this.detail.length,
          no_bayar: this.detail.length + 1,
          payment_date: values.payment_date,
          payment_value: values.payment_value,
          item_name: values.item_name,
          type_tax: values.type_tax ? values.type_tax : 'non_tax'
        }

        if(this.page_state == 'Edit'){
          this.addDetailUpdate(payload);
        }else {
          this.detail.push(payload)
          this.refreshDetailNumber()
        }

        this.$message.success('Data bayar berhasil ditambahkan')
        this.restFormDetail()
      })
    },

    deleteDetail(param) {
      this.delete_id_state = param.id
      if(this.page_state == 'Edit'){
        this.deleteDetailUpdate(param)
      }else {
        this.detail = this.detail.filter(item => item.key !== param.key)
      }
      this.$message.success('Data bayar berhasil dihapus')
      this.refreshDetailNumber()
    },

    restFormDetail(){
      this.form_detail.resetFields()
    },

    editAction(params){
      this.form_state = 'edit'
      this.detail_state = params

      this.is_tax = params.type_tax == "non_tax" ? "0" : "1";
      this.old_type_tax = params.type_tax

      this.form_detail.setFieldsValue({
        payment_date: params.payment_date,
        payment_value: params.payment_value,
        item_name: params.item_name
      })

      if(this.is_tax == '1'){
        this.$nextTick(() => {
          this.form_detail.setFieldsValue({
            type_tax: params.type_tax
          });
        });
      }

      if(this.page_state == 'Edit'){
        this.detail_id_state = params.id
      }
    },

    cancelEdit(){
      this.form_state = 'create'
      this.old_type_tax = ''
      this.detail_state = {}
      this.form_detail.resetFields()
    },

    editDetail() {
      
      this.form_detail.validateFields((err, values) => {
        if (err) return

        const index = this.detail.findIndex(
          item => item.no_bayar === this.detail_state.no_bayar
        )

        if (index === -1) {
          this.$message.error('Data tidak ditemukan')
          return
        }

        const old_type = String(this.old_type_tax || '').toLowerCase();
        const new_type = String(values.type_tax || '').toLowerCase();
        const is_pph = old_type.includes('pph');
        const new_is_pph = new_type.includes('pph');

        const oldPayment = is_pph ? 0 : Number(this.detail[index].payment_value || 0)
        const newPayment = Number(values.payment_value || 0)
        
        if(newPayment == 0){
          this.$message.error(`Nilai bayar tidak boleh 0`)
          return
        }

        // Saldo yang tersedia = sisa sekarang + nilai lama
        // const available = this.remaining_balance + oldPayment

        // if (newPayment > available && !new_is_pph) {
        //   this.$message.error(`Nilai bayar tidak boleh melebihi sisa bayar (${this.customFormatCurrency('IDR', available)})`)
        //   return
        // }

        if(this.page_state == 'Edit'){
          this.updateDetail(values)
        }else {
          this.detail[index].payment_date = values.payment_date
          this.detail[index].type_tax = values.type_tax ? values.type_tax : 'non_tax'
          this.detail[index].item_name = values.item_name
          this.detail[index].payment_value = newPayment
        }

        this.$message.success('Data bayar berhasil diubah')
        this.form_state = 'create'
        this.old_type_tax = ''
        this.restFormDetail()
      })
    },

    beforeUpload(file) {
      this.file_state = file
      return false
    },

    addDocument() {
      this.form_document.validateFields( async (err, values) => {
        if(err){
          return
        }

        const file = {
          key: this.documents.length,
          no: this.documents.length + 1,
          file_name: values.document_name,
          size: this.file_state.size,
          type: this.file_state.type,
          file: this.file_state
        }

        if(this.page_state == 'Create'){
          this.documents.push(file)
          this.refreshDocumentNumber()
        }else {
          try {
            this.loading.add = true
            const payload = new FormData();
            payload.append('manifest_id', this.id);
            payload.append('files', file.file);
            payload.append('file_name', file.file_name);

            const response = await axios({
              method: "POST",
              url: this.$serviceUrl + "kewajiban/document",
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "X-API-KEY": this.getAuth.apikey,
              },
              data: payload
            })
            if(response.data){
              this.documents = response.data.data
            }
            this.loading.add = false

          } catch (error) {
            this.loading.add = false
            console.log(error);
          }
        }

        this.$message.success('Dokumen berhasil ditambahkan')

        this.file_state = null
        this.form_document.resetFields()
      })
    },

    refreshDocumentNumber() {
      this.documents = this.documents.map((item, index) => ({
        ...item,
        key: index,
        no: index + 1
      }))
    },

    async deleteDocument(values) {
      if(this.page_state == 'Create'){
        this.documents = this.documents.filter(item => item.key !== values.key)
        this.refreshDocumentNumber()
      }else {
        try {
          this.loading.list = true
          const payload = {
            manifest_id: this.id,
            doc_id: values.id
          }

          const response = await axios({
            method: "DELETE",
            url: this.$serviceUrl + "kewajiban/document",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            data: payload
          })

          if(response.data){
            this.documents = response.data.data
          }
          this.loading.list = false

        } catch (error) {
          this.loading.list = false
          console.log(error);
        }
      }
      this.$message.success('Dokumen berhasil dihapus')
    },

    viewDocument(record) {
      if(record.onlyview){
        this.loading.print = true
        axios({
          method: "get",
          url: this.$serviceUrl + record.path,
          processData: false,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const byteCharacters = atob(response.data.message);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          
          const excelBlob = new Blob([byteArray], { type: record.type });
          const blobURL = URL.createObjectURL(excelBlob);
          const newTab = window.open('', '_blank');
          if (newTab) {
              const downloadLink = newTab.document.createElement('a');
              downloadLink.href = blobURL;
              downloadLink.download = record.file_name+".xlsx";

              newTab.document.body.appendChild(downloadLink);
              downloadLink.click();

              setTimeout(() => {
                  newTab.close();
                  URL.revokeObjectURL(blobURL);
              }, 100);
          }
          this.loading.print = false
        })
        .catch(()=>{})
      } else if(this.page_state == 'Edit'){
        this.fileHandler(record.id, record.file_name);
      }else {
        const url = URL.createObjectURL(record.file)
        window.open(url, '_blank')

        setTimeout(() => {
          URL.revokeObjectURL(url)
        }, 1000)
      }
    },

    confirm(){
      Modal.confirm({
        title: 'Confirm Submit',
        content: 'Are you sure want to submit ?',
        okText: 'Submit',
        cancelText: 'Cancel',
        onOk: () => {
          this.onSubmit()
        }
      });
    },

    async onSubmit(){
      this.loading.submit = true
      
      const isrekap = ['rekap_lkpd', 'rekap_klaim_kesehatan', 'rekap_cc_ticket'].includes(this.information_state.type_data);

      if (this.documents.length == 0 && !isrekap) {
        this.$message.error(`File dokumen wajib diupload`)
        this.loading.submit = false
        return
      }
      
      if(this.page_state == 'Create'){
        try {
          const budget_array = this.information.budget_item.split(";");
          const payload = new FormData()
          if(this.edit_state == 'reminder'){
            payload.append('directorate', this.information_state.directorate)
            payload.append('detail_id', this.information_state.anggaran_dtl_id)
            payload.append('detail_val_id', this.information_state.anggaran_dtl_val_id)
          }else {
            payload.append('directorate', this.selected_directorate)
            payload.append('detail_id', budget_array[0])
            payload.append('detail_val_id', budget_array[1])
          }

          payload.append('trans_id', this.information_state.reminder_ap_id)
          payload.append('type_trans', this.information_state.type_data)
          payload.append('create_date', this.information.create_date)
          payload.append('due_date', moment(this.information.due_date).format("YYYY-MM-DD"))
          payload.append('description', this.information.description)
          payload.append('beneficiary', this.information.beneficiary)
          payload.append('type', this.information.kewajiban_type)
          payload.append('value', this.information.kewajiban_value)
          payload.append('currency', this.information.currency)
          payload.append('kurs', this.information.kurs_value)
          payload.append('invoice_number', this.information.invoice_number)
          payload.append('details', JSON.stringify(this.detail))
          payload.append('grand_total', (this.total_payment + this.total_tax))
          this.documents.forEach((item, index) => {
            payload.append(`files[${index}]`, item.file);
            payload.append(`file_names[${index}]`, item.file_name);
          });
          if (this.information.user_cc) {
            payload.append('user_cc_id', this.information.user_cc)
          }
          if(this.information.prospek)
            payload.append('prospek', this.information.prospek)

          payload.append('catatan', this.information.catatan ? this.information.catatan : '')

          const response = await axios({
            method: "POST",
            url: this.$serviceUrl + "kewajiban",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            data: payload
          })
          if(response){
            this.displayMessage("success-save")
            this.$router.push({
              name: 'kewajiban_list'
            })
          }
          this.loading.submit = false
          
        } catch (error) {
          this.loading.submit = false
          console.log(error);
        }
      } else {
        try {
          const payload = {
            manifest_id: this.id
          }

          const response = await axios({
            method: "PUT",
            url: this.$serviceUrl + "kewajiban/revise",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            data: payload
          })

          if(response){
            this.displayMessage("success-save")
            this.$router.push({
              name: 'kewajiban_list'
            })
          }

          this.loading.submit = false
        } catch (error) {
          this.loading.submit = false
          console.log(error);
        }
      }
      
    },

    async fetchDataEdit(){
      try {
        this.loading.page = true
        this.edit_state = ''
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/revise`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: {
            manifest_id: this.id
          }
        })

        if(response.data){
          this.information_state = response.data.data
          this.information_state['type_data'] =  response.data.data.type_trans
          this.information_state['reminder_ap_id'] =  response.data.data.trans_id
          this.detail_state = response.data.details
          this.document_state = response.data.files
          this.documents = response.data.files
          this.project_state = response.data.project

          if (response.data.data.type_trans == "reminder")
            this.edit_state = 'reminder'

          this.mappingBudget(this.project_state.jns_anggaran_id)

          this.form_information.setFieldsValue({
            create_date: this.moment(this.information_state.create_dt).format("YYYY-MM-DD"),
            due_date: this.information_state.tgl_kewajiban,
            description: this.information_state.description,
            beneficiary: this.information_state.beneficiary,
            kewajiban_type: this.information_state.jenis_kewajiban,
            kewajiban_value: this.information_state.nilai,
            currency: this.information_state.currency,
            kurs_value: this.information_state.kurs_idr,
            invoice_number: (this.information_state.no_reminder_ap || this.information_state.no_invoice),
          })

          if(this.information_state.user_cc_id){
            this.is_cc = true
            this.$nextTick(() => {
              this.form_information.setFieldsValue({
                is_cc: '1',
                user_cc: this.information_state.user_cc_id
              })
            })
          }
          this.is_cc_disabled = this.showCc(this.information_state.type_trans)

          this.detail_state.forEach((element, index) => {
            const payload = {
              key: index,
              no_bayar: index+1,
              payment_date: element.tanggal_byr,
              payment_value: element.nilai_bayar,
              seq_dtl: element.seq_dtl,
              no_bayar_seq: element.no_bayar,
              no_rencana_bayar: element.no_rencana_bayar,
              id: element.kewajiban_dtl_id,
              item_name: element.nama_item,
              type_tax: element.type_tax,
              required: (index == 0 ? true : false)
            }
            this.detail.push(payload)
          });

          if(this.selectedCostCenter=='07'){
            this.getProspectList(this.anggaran_id_state).then(()=>{
              this.$nextTick(() => {
                this.form_information.setFieldsValue({
                  prospek: this.information_state.prospect_id,
                })
              });
            });
          }
          
          this.initialDocTrans();
        }
        this.loading.page = false
        
      } catch (error) {
        this.loading.page = false
        console.log(error);
      }
    },

    async updateInformation(values){
      try {
        this.loading.next = true
        const budget_array = values.budget_item.split(";");
        const findDirectorate = this.cost_center_list.find((e) => e.id == this.project_state.anggaran_id)
        let directorate = '';
        if(findDirectorate){
          directorate = findDirectorate.directorate
        } else {
          if(this.id){
            this.mappingBudget(this.project_state.jns_anggaran_id)
            // this.fetchItemAnggaran(true)
            this.updateInformation(values)
            return 
          }
        }

        const payload = {
          manifest_id: this.id,
          due_date: values.due_date,
          description: values.description,
          directorate: directorate,
          beneficiary: values.beneficiary,
          type: values.kewajiban_type,
          value: values.kewajiban_value,
          currency: values.currency,
          kurs: values.kurs_value,
          detail_id: budget_array[0],
          detail_val_id: budget_array[1],
          invoice_number: values.invoice_number,
          user_cc_id: values.user_cc ? values.user_cc : null
        }
        
        const response = await axios({
          method: "PUT",
          url: this.$serviceUrl + `kewajiban/information`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          data: payload
        })

        if(response){
          this.$message.success('Information berhasil diupdate')
          this.loading.next = false
          this.current++;
        }
      } catch (error) {
        this.loading.next = false
        console.log(error);
      }
    },

    async updateDetail(values){
      try {
        this.loading.table_detail = true
        const payload = {
          manifest_id: this.id,
          detail_id: this.detail_id_state,
          payment_date: values.payment_date,
          payment_value: values.payment_value,
          type_tax: values.type_tax ? values.type_tax : 'non_tax',
          item_name: values.item_name,
          grand_total: (this.total_payment + this.total_tax)
        }

        const response = await axios({
          method: "PUT",
          url: this.$serviceUrl + `kewajiban/detail`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          data: payload
        })
        if(response.data){
          this.detail_state = response.data.data
          this.detail = []
          this.detail_state.forEach((element, index) => {
            const payload = {
              key: index,
              no_bayar: index+1,
              payment_date: element.tanggal_byr,
              payment_value: element.nilai_bayar,
              seq_dtl: element.seq_dtl,
              no_bayar_seq: element.no_bayar,
              no_rencana_bayar: element.no_rencana_bayar,
              id: element.kewajiban_dtl_id,
              item_name: element.nama_item,
              type_tax: element.type_tax
            }
            this.detail.push(payload)
          });
          this.form_information.setFieldsValue({
            kewajiban_value: (this.total_payment + this.total_tax)
          })
        }
        this.loading.table_detail = false

      } catch (error) {
        this.loading.table_detail = false
        console.log(error);
      }
    },

    async addDetailUpdate(values){
      try {
        this.loading.add = true
        const payload = {
          manifest_id: this.id,
          payment_date: values.payment_date,
          payment_value: values.payment_value,
          item_name: values.item_name,
          type_tax: values.type_tax
        }

        const response = await axios({
          method: "POST",
          url: this.$serviceUrl + `kewajiban/detail`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          data: payload
        })

        if(response.data){
          this.detail_state = response.data.data
          this.detail = []
          this.detail_state.forEach((element, index) => {
            const payload = {
              key: index,
              no_bayar: index+1,
              payment_date: element.tanggal_byr,
              payment_value: element.nilai_bayar,
              seq_dtl: element.seq_dtl,
              no_bayar_seq: element.no_bayar,
              no_rencana_bayar: element.no_rencana_bayar,
              id: element.kewajiban_dtl_id,
              item_name: element.nama_item,
              type_tax: element.type_tax
            }
            this.detail.push(payload)
          });

          this.form_information.setFieldsValue({
            kewajiban_value: (this.total_payment + this.total_tax)
          })
        }
        this.loading.add = false

      } catch (error) {
        this.loading.add = false
        console.log(error);
      }
    },

    async deleteDetailUpdate(values){
      try {
        this.loading.delete = true;
        const payload = {
          manifest_id: this.id,
          detail_id: values.id
        }

        const response = await axios({
          method: "DELETE",
          url: this.$serviceUrl + `kewajiban/detail`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          data: payload
        })

        if(response.data){
          this.detail_state = response.data.data
          this.detail = []
          this.detail_state.forEach((element, index) => {
            const payload = {
              key: index,
              no_bayar: index+1,
              payment_date: element.tanggal_byr,
              payment_value: element.nilai_bayar,
              seq_dtl: element.seq_dtl,
              no_bayar_seq: element.no_bayar,
              no_rencana_bayar: element.no_rencana_bayar,
              id: element.kewajiban_dtl_id,
              item_name: element.nama_item,
              type_tax: element.type_tax
            }
            this.detail.push(payload)
          });

          this.form_information.setFieldsValue({
            kewajiban_value: (this.total_payment + this.total_tax)
          })
        }
        this.loading.delete = false;

      } catch (error) {
        this.loading.delete = false;
        console.log(error);
        
      }
    },

    async fileHandler(id, fileName){
      try {
        this.loading.list = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/file/${id}`,
          responseType: "blob",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          }
        })

        this.loading.list = false

        const blob = response.data;
        const mimeType = blob.type;
        const url = window.URL.createObjectURL(blob);

        // PDF atau gambar -> buka tab baru
        if (
          mimeType === "application/pdf" ||
          mimeType.startsWith("image/")
        ) {
          window.open(url, "_blank");
          return;
        }

        const link = document.createElement("a");
        link.href = url;

        const disposition = response.headers["content-disposition"];
        let filename = fileName;

        if (disposition) {
          const match = disposition.match(/filename="?(.+?)"?$/);
          if (match) {
            filename = match[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.log(error);
        this.loading.list = false
        
      }
    },

    findNodeByValue(nodes, value) {
      for (const node of nodes) {
        if (node.value === value) {
          return node
        }

        if (node.children) {
          const result = this.findNodeByValue(node.children, value)
          if (result) return result
        }
      }

      return null
    },

    async setNodeValueByKey(tree, targetId, updateData) {
      await _.forEach(tree, (node) => {
        if (node.key === targetId) {
          _.assign(node, updateData);
          return false;
        }
        
        if (node.children && node.children.length > 0) {
          this.setNodeValueByKey(node.children, targetId, updateData);
        }
      });
    },

    onChangeItemAnggaran(val){
      const item = this.findNodeByValue(this.item_anggaran_list, val);
      this.constraint_value = item ? item.remaining_value : 0

      this.$nextTick(() => {
        this.form_information.validateFields(['kewajiban_value'], { force: true})
      })
    },

    validateKewajibanValue(rule, value, callback) {
      const { budget_item } = this.form_information.getFieldsValue(['budget_item']);
      const budget = this.information_state ? this.information_state.anggaran_dtl_id+";"+this.information_state.anggaran_dtl_val_id : budget_item
      
      if (value && budget_item !== undefined &&Number(value) > Number(this.constraint_value)) {
        callback(`Nilai Kewajiban tidak boleh melebihi ${this.customFormatCurrency('IDR', this.constraint_value)}` )
        return
      } else if( budget == undefined ){
        callback(`Pilih Item Anggaran terlebih dahulu` );
        return
      }
      callback()
    },

    onChangeIsTax(e){
      this.is_tax = e.target.value
    },

    onChangeIsCc(e){
      this.is_cc = e.target.value
    },

    onChangeTax(val){
      // console.log(val);
      
    },

    findTax(item){
      const find = this.getType_tax.find((e) => e.value == item);
      if(find){
        return find.text
      } else return item
    },

    async fetchDataEditReminder(id){
      try {
        this.loading.page = true
        this.edit_state = 'reminder'
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `reminder/revise`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: {
            manifest_id: id
          }
        })

        if(response.data){
          this.information_state = response.data.data
          this.detail_state = response.data.details
          this.project_state = response.data.project
          
          if(this.information_state.type_data !== 'reminder'){
            this.edit_state = 'rekap'
          } else {
            this.mappingBudget(this.project_state.jns_anggaran_id)
          }

          this.form_information.setFieldsValue({
            due_date: this.information_state.tanggal_kewajiban,
            description: this.information_state.description,
            beneficiary: this.information_state.beneficiary,
            kewajiban_type: this.information_state.jenis_kewajiban,
            kewajiban_value: this.information_state.nilai,
            currency: this.information_state.currency,
            kurs_value: this.information_state.kurs_idr,
            reminder_type: this.information_state.jenis_reminder_ap,
            invoice_number: (this.information_state.no_reminder_ap || this.information_state.no_invoice),
          })

          if(this.information_state.user_cc_id){
            this.is_cc = true
            this.$nextTick(() => {
              this.form_information.setFieldsValue({
                is_cc: '1',
                user_cc: this.information_state.user_cc_id
              })
            })
          }
          
          this.is_cc_disabled = this.showCc(this.information_state.type_data)

          // this.anggaran_id_state = this.project_state ? this.project_state.anggaran_id : null;
          // this.peruntukan_id_state = this.project_state ? this.project_state.peruntukan_id : null

          this.detail_state.forEach((element, index) => {
            const payload = {
              key: index,
              no_bayar: index+1,
              payment_date: element.tanggal_byr,
              payment_value: element.nilai_bayar,
              seq_dtl: element.seq_dtl,
              no_bayar_seq: element.no_bayar,
              no_rencana_bayar: element.no_rencana_byr,
              id: element.reminder_ap_dtl_id,
              item_name: element.nama_item,
              type_tax: element.type_tax
            }
            this.detail.push(payload)
          });

          this.initialDocTrans();
        }
        this.loading.page = false
        
      } catch (error) {
        this.loading.page = false
        console.log(error);
      }
    },

    showCc(val){
      const arr = ['rekap_lkpd', 'rekap_klaim_kesehatan', 'rekap_cc_ticket'];
      return arr.some(item => val.includes(item));
    },

    filterUserCC(input, option) {
      const label = String(option.componentOptions.propsData.label || '').toLowerCase()
      const search = String(input || '').toLowerCase()

      return label.indexOf(search) !== -1
    },

    async getProspectList(anggaran_id){
      this.listProspect = [];
      this.loading.prospect = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: anggaran_id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = response.data.data ? response.data.data : [];
        this.loading.prospect = false;
      })
      .catch(() => {
      });
    },

    initialDocTrans(){
      if(this.information_state.jenis_kewajiban =='Rekapitulasi'){
        let name_page = "Recapitulation (CC Tiket)";
        let idman     = this.information_state.reminder_ap_id;
        let path      = "rekap_tiket/cetak?id_rekap_cc_tiket=" + idman;
        if(this.information_state.type_data == 'rekap_klaim_kesehatan'){
          name_page   = 'Recapitulation (Klaim Kesehatan)';
          path        = "rekap_kesehatan/cetak?id_rekap_klaim=" + idman;
        }else if(this.information_state.type_data == 'rekap_lkpd'){
          name_page   = 'Recapitulation (LKPD)';
          path        = "rekap_lkpd/cetak?id_rekap_lkpd=" + idman;
        }else if(this.information_state.type_data == 'rekap_lembur'){
          name_page   = 'Recapitulation (Lembur) - '+this.information_state.no_reminder_ap;
          path        = "kewajiban/rekapLemburCetak?id=" + idman;
        }

        this.documentsFromTrans = [{
          file_name: name_page,
          key:0,
          no:1,
          size:1,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          path: path,
          onlyview: true
        }]
      }
    },
    // end_methods
  },
}
</script>

<style lang="less">
.c_primary {
  // height: 100%;
  .ant-card-head-title{
    margin-right: 0px!important;
  }
  .cmain-title{
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {color: #fff;}
    path{color: #fff;}
    span {color: #fff;}
  }
  .hdr_plfn{
    .ant-table-title{
      padding-bottom: 0px;
    }
  }
  .option_plfn{
    td{
    padding: 0px;
    }
  }
  .hdr_plfn_selection{
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused  {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv{
    .ant-input-number{
      justify-content: flex-end;
    }
    .ant-input-number-input{
      text-align: right;
      display: block;
    }
  }
  .row_h{
    margin-right: 11px;
  }

  .ngabango{
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate{
  .ant-input-number-input{
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables{
  // .ant-table-row {
    .ant-table-thead {
      background: #c1c1c1;
      font-weight: bolder;
    }
    tr:first-child {
      td:hover {
        background: #00ca8e;
      }
    }
    td:nth-child(4){
      background: #c1c1c1;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td {
      background: none;
    }

    .ant-table-thead > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-thead > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: #c1c1c1;
    }
  // }
}

.overvalueRow{
  background-color: fade(@color-primary, 35%);
}

.custom-card .ant-card-body {
  padding: 0px !important;
}

// .custom-table .ant-table {
//   border: none !important;
// }

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

.ant-table-content {
  border-right: none !important;
}

.ant-table-small {
    border: 1px solid #e8e8e8;
    border-left: none !important;
    border-radius: 4px;
}

// .custom-table .ant-table-bordered > .ant-table-container {
//   border: none !important;
// }

.single-parent {
  text-transform: uppercase;
  font-weight: bold;
}

.summary-row td {
  background: #f3e8e8 !important;
  font-weight: bold;
}

.chart-container{
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-big-text .ant-progress-text {
  font-size: 22px !important;
  font-weight: bold;
}

.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.link-hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: color .2s ease;
}

.link-hover:hover {
  color: #1677ff;
  text-decoration: underline;
}

.mt-5{
  margin-top: 10px;
}

.flex-items-center{
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.flex-wrapper {
  display: flex;
  gap: 10px;
}

.flex-wrapper .flex-items {
  flex: 1;
}

.card-footer{
  display: flex;
  width: 100%;

  .btn-add {
    margin-left: auto;
  }

  .btn-update {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
}

.col-flex {
  display: flex;
}

.card-flex {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-flex .ant-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-flex .ant-table-wrapper {
  flex: 1;
}

.table-footer {
  margin-top: auto;
  padding: 14px 16px;
}

.footer-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.footer-row:last-child {
  margin-bottom: 0;
}

.footer-label {
  width: 120px;
  font-weight: 600;
}

.footer-separator {
  width: 20px;
  text-align: center;
}

.footer-value {
  flex: 1;
  text-align: right;
  font-weight: 600;
}

.steps-action {
  padding-top: 0.875rem;
}

span.ant-select-selection-selected-value {
  width: 100%;
}

.table-note {
  margin-top: -50px;
  padding: 10px;
  font-size: 0.75rem;
}
</style>